// @ts-nocheck
import { RESOURCE_DETAIL_PAGE_KEY } from "../constants";

export default {
  es: {
    [RESOURCE_DETAIL_PAGE_KEY]: {
      FREE_DOWNLOAD: "Descárgalo gratis",
      DOWNLOADS: "Descargas",
      INFORMATION: "Información",
      SUBSCRIBE: "Suscríbete y obtén el mejor contenido en tu bandeja",
      SIGNUP: "Inscríbete",
      RELATED_CONTENT: "Contenido Relacionado",
      TUTORIALS: "Sobre el tutorial",
      POST_BY: "Posteado por",
      DIALOG_GET_PHONE_TITLE: "Estemos en contacto",
      DIALOG_GET_PHONE_SUBTITLE:
        "Ingresa tu número de teléfono para ayudarte a crear un plan de estudios, conversar sobre tu experiencia o brindarte promociones exclusivas.",
    },
  },
};
